import script from "./CreateAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateAddress.vue?vue&type=script&setup=true&lang=ts"

import "./CreateAddress.vue?vue&type=style&index=0&id=783f485a&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/bj-International-card-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-783f485a"]])

export default __exports__